<div class="search-container" style="display: none;" id="search_inner" *ngIf="!IsMobilRental">
<div class="search_inner">
    <input class="form-control" type="text" name="search" placeholder="Search" tabindex="1">
    <button class="head_search_ico" [ngClass]="{ 'topHeaderMR': IsMobilRental }" type="submit"><i class="header_search"></i></button>
    <div class="search-suggestion">
    </div>
  </div>
  <div class="close_search"></div>
</div>